/**
 * WIP 2024 03 — Mirror `SystemManagmentDAO`, and `ConsumerDAO` in Mobile, prepare for possible extact and import from an `@iotv/api` module
 * -- `@amplify` would need to be injected
 */
import { batchDelete } from '../daoFunctions/Batch/delete';
import { batchPut } from '../daoFunctions/Batch/put';
import { getDeviceContext, getEntityContext } from '../daoFunctions/ContextQueries';
import { getProximateItems } from '../daoFunctions/Geo/getProximateItems';
import { baseQuery, batchGet, createAndLink, deleteExact, deleteObject, getAdjacent2Wrapper, getApexInstances, getApexGroupsOfSupportedType as getApexGroups, getExact, getGraphQueryResponse, getObjectHistory, getOne, ioExport, ioImport, ioStatus, link, save, scan, simpleAdjacentQuery, unlink, saveObjectHistory, } from '../daoFunctions/daoFunctions';
import { getLinkableItems } from '../daoFunctions/getLinkableItems';
import { getGraphQueryRequestV2 } from '../daoFunctions/GraphQueries/recursiveFilteredGraphQuery';
import { itemIsDeletable } from '../daoFunctions/itemIsDeletable';
import { getDashboardData } from '../daoFunctions/Dashboard/getDashboardData';
import { getBucketedReadings } from '../daoFunctions/Dashboard/getBucketedReadings';
const debug = process.env.REACT_APP_DEBUG && false;
/**
 * Retrieves `BaseData` items of a {@link type} which are named in the current config from the datastore
 */
const getNamedApexItems = async ({ type }) => {
    let res = { err: null, data: null };
    try {
        res = await getApexInstances(type);
        debug && console.log(`ConsumerDAO getNamedApexItems ${type}`, { res });
    }
    catch (e) {
        console.log(`Err: ConsumerDAO getNamedApexItems`, e.message);
        res.err = e;
    }
    return res;
};
const getApexGroupsOfSupportedType = async (supportedType) => {
    return await getApexGroups(supportedType);
};
/**
 * **Consumer DAO**
 *
 * Provides access to `ConsumerDataAPI` methods, such as:
 * - {@link createAndLink}
 * - {@link link}
 * - {@link unlink}
 * - {@link save}
 * - {@link deleteObject}
 *
 * - {@link getOne}
 * - {@link getAdjacent2Wrapper | getAdjacent}
 * - {@link getGraphQueryResponse}
 * - {@link getGraphQueryRequestV2}
 *
 * Many more methods are available
 */
const ConsumerDao = {
    save,
    saveObjectHistory,
    createAndLink,
    scan,
    deleteObject,
    deleteExact,
    link,
    unlink,
    getOne,
    getDashboardData,
    getExact,
    baseQuery,
    getAdjacent: getAdjacent2Wrapper,
    getGraphQueryResponse,
    getLinkableItems,
    itemIsDeletable,
    getNamedApexItems,
    getApexGroupsOfSupportedType,
    batchGet,
    batchPut,
    batchDelete,
    getGraphQueryRequestV2,
    getObjectHistory,
    getBucketedReadings,
    simpleAdjacentQuery,
    getEntityContext,
    getDeviceContext,
    getProximateItems,
    io: { status: ioStatus, import: ioImport, export: ioExport },
};
export { ConsumerDao };
